import { render, staticRenderFns } from "./HistoricalComparisonBarChart.vue?vue&type=template&id=c0bb9fda&scoped=true&"
import script from "./HistoricalComparisonBarChart.vue?vue&type=script&lang=js&"
export * from "./HistoricalComparisonBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalComparisonBarChart.vue?vue&type=style&index=0&id=c0bb9fda&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb9fda",
  null
  
)

export default component.exports